import { InjectionToken } from "@angular/core";

export interface BiEnvironment {
  production: boolean;
  appInsights: {
    enabled: boolean;
    instrumentationKey: string;
  };
}

/**
 * Token for injecting the current environment configuration.
 */
export const BI_ENVIRONMENT = new InjectionToken<BiEnvironment>("BI_ENVIRONMENT");
